export const USERS = 'management/users/all'
export const USER = 'management/users/edit'
export const CREATE_USER = 'management/users/add'
export const UPDATE_USER = 'management/users/update'
export const DELETE_USER = 'management/users/delete'
